(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("website", [], factory);
	else if(typeof exports === 'object')
		exports["website"] = factory();
	else
		root["website"] = factory();
})(this, function() {
return 